import { useLiquidityCheck } from '../hooks/use-liquidity-check'

const LiquidityUpdater = () => {
  useLiquidityCheck()
  return null
}

export default LiquidityUpdater
